import { Record } from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    results: {},
    eventosSelecionadosAcumulado: [],
});

class Store extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.LIST_AMOUNT_BY_SLOT_FINISH:
                if (action.eventId)
                    return state.set('results', Object.assign({}, state.results, {[action.eventId]: action.result}));
                return state;

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'eventosSelecionadosAcumulado')
                    return state.set('eventosSelecionadosAcumulado', action.value);
                return state;

            default:
                return state;
        }
    }
}

export default new Store();



// WEBPACK FOOTER //
// src/stores/AcumuladoVendasStore.js